import type { ReactNode } from "react";
import { Eyebrow } from "@/components/Eyebrow";
import { Reveal } from "@/components/Reveal";

export function LegalPage({
  eyebrow,
  title,
  intro,
  updated,
  children,
}: {
  eyebrow: string;
  title: string;
  intro: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <>
      <section className="bg-brand-cream pt-16 pb-12 border-b border-brand-gold/20">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="font-display text-brand-charcoal text-4xl md:text-6xl mt-3">{title}</h1>
          <p className="text-brand-warm-gray mt-4 font-italic-serif italic text-lg">{intro}</p>
          <p className="text-xs uppercase tracking-[0.2em] text-brand-warm-gray mt-4">
            Ultimo aggiornamento · {updated}
          </p>
        </div>
      </section>
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <Reveal>
            <article className="legal-prose space-y-8 text-brand-charcoal text-[15px] leading-[1.75]">
              {children}
            </article>
          </Reveal>
        </div>
      </section>
    </>
  );
}

export function LegalSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <h2 className="font-display text-2xl md:text-3xl text-brand-charcoal mb-3">{title}</h2>
      <div className="space-y-3 text-brand-charcoal/85">{children}</div>
    </section>
  );
}